<template>
  <div
    class="row news H_img_V_Title_Lead m-0"
    :class="{ 'video-play-icon': post.format === 4 }"
  >
    <div class="col-5 pl-0 pr-3">
      <a :href="post.postUrl">
        <div class="img-wrap">
          <img
            :src="post.principalImage.url"
            :alt="post.principalImage.alt"
            :title="post.principalImage.title"
          />
        </div>
        <div
          v-if="post.sponsoredText"
          class="sponsored"
          v-html="post.sponsoredText"
        ></div>
      </a>
    </div>
    <div class="col-7 pl-3 pr-3">
      <a
        :href="post.postUrl"
        class="kicker"
        v-bind:class="post.section.className"
        v-html="post.header"
      ></a>
      <span class="date-news" v-html="postDate"></span>
      <h2 class="tt">
        <a
          :href="post.postUrl"
          v-bind:class="post.section.className"
          v-html="post.title"
        ></a>
      </h2>
      <span class="subtitle" v-if="post.subTitle" v-html="post.subTitle"></span>
      <p v-html="post.lead"></p>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    post: Object,
    groupName: String,
  },
  computed: {
    postDate: function () {
      return moment(this.post.create).format("DD/MM/YYYY");
    },
  },
};
</script>
